import { Component, Vue } from "vue-property-decorator"

@Component
class EventBus extends Vue {}
export default new EventBus()
